import { render } from "./LiveAds.vue?vue&type=template&id=41b7c30a"
import script from "./LiveAds.vue?vue&type=script&lang=js"
export * from "./LiveAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__